// @flow
export const arrayContainsDomain = (
	domain_array: Array<{ site: string }>,
	url: string,
	options: { sanitize: boolean } = { sanitize: true }
) => {
	var sanitized_url = options.sanitize ? sanitizeUrl(url) : url;
	let contains_url = domain_array.some((domain) => {
		return domain.site === sanitized_url;
	});
	return contains_url;
};

export const sanitizeUrl = (url: string) => {
	let has_protocol = /^.+\:\/{1,3}/.test(url);
	if (!has_protocol) {
		// the URL class requires a valid URL, so we make sure it has a protocol
		url = `https://${url}`;
	}

	try {
		var parsed_url = new URL(url);
	} catch (e) {
		throw "Invalid website submitted";
	}

	// Remove the protocol from the beginning of URL
	let sanitized_url = parsed_url.href.replace(/^.+\:\/{1,3}/, "");

	// Remove the www subdomain (since both www and non-www should be blocked)
	let domain_parts = sanitized_url.split(".");
	if (domain_parts.length === 3 && domain_parts[0] === "www") {
		domain_parts.shift();
		sanitized_url = domain_parts.join(".");
	}

	// Ensure there is no trailing slash
	sanitized_url = sanitized_url.replace(/\/$/, "");

	return sanitized_url;
};



// WEBPACK FOOTER //
// ../shared/store/domains/util.js